// src/components/Hero.js
import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section style={styles.hero}>
      <div style={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={styles.content}
        >
          <motion.div
            animate={{ 
              scale: [1, 1.03, 1],
            }}
            transition={{ 
              duration: 4,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            style={styles.badge}
          >
            <span style={styles.badgeText}>✨ Ahorra tiempo y dinero</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            style={styles.title}
          >
            Encuentra lo que buscas<br />
            <span style={styles.highlight}>al mejor precio</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            style={styles.subtitle}
          >
            Deja que nuestros expertos busquen por ti. Sin estrés, sin perder tiempo.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            style={styles.ctaContainer}
          >
            <a
              href="#download"
              style={styles.primaryButton}
            >
              Comenzar Ahora
            </a>
          </motion.div>
        </motion.div>

        {/* Formas decorativas */}
        <motion.div
          style={styles.shape1}
          animate={{ 
            y: [0, -10, 0],
            rotate: [0, 5, 0],
          }}
          transition={{ 
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          style={styles.shape2}
          animate={{ 
            y: [0, 15, 0],
            x: [0, -10, 0],
          }}
          transition={{ 
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1
          }}
        />
      </div>
    </section>
  );
};

const styles = {
  hero: {
    paddingTop: '120px',
    paddingBottom: '100px',
    backgroundColor: 'linear-gradient(135deg, #f5f7ff 0%, #eef1ff 100%)',
    position: 'relative',
    overflow: 'hidden',
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0 1.5rem',
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
  },
  content: {
    width: '100%',
  },
  badge: {
    display: 'inline-block',
    backgroundColor: 'rgba(67, 97, 238, 0.1)',
    color: '#4361ee',
    padding: '0.4rem 1.2rem',
    borderRadius: '50px',
    marginBottom: '2rem',
    backdropFilter: 'blur(4px)',
    border: '1px solid rgba(67, 97, 238, 0.2)',
  },
  badgeText: {
    fontSize: '0.95rem',
    fontWeight: '600',
    fontFamily: "'Poppins', sans-serif",
  },
  title: {
    fontSize: '3.4rem',
    fontWeight: '800',
    color: '#212529',
    lineHeight: 1.2,
    marginBottom: '1.5rem',
    fontFamily: "'Poppins', sans-serif",
  },
  highlight: {
    color: '#4361ee',
    position: 'relative',
  },
  subtitle: {
    fontSize: '1.25rem',
    color: '#6c757d',
    lineHeight: 1.6,
    marginBottom: '2.5rem',
    maxWidth: '650px',
    margin: '0 auto 2.5rem',
  },
  ctaContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  primaryButton: {
    display: 'inline-block',
    backgroundColor: '#4361ee',
    color: 'white',
    padding: '1rem 2.2rem',
    borderRadius: '14px',
    textDecoration: 'none',
    fontWeight: '700',
    fontSize: '1.15rem',
    boxShadow: '0 8px 25px rgba(67, 97, 238, 0.4)',
    transition: 'all 0.3s ease',
    border: 'none',
    cursor: 'pointer',
    fontFamily: "'Poppins', sans-serif",
  },
  // Formas decorativas
  shape1: {
    position: 'absolute',
    top: '15%',
    right: '10%',
    width: '80px',
    height: '80px',
    borderRadius: '20px',
    backgroundColor: 'rgba(67, 97, 238, 0.08)',
    transform: 'rotate(15deg)',
    zIndex: 1,
  },
  shape2: {
    position: 'absolute',
    bottom: '20%',
    left: '8%',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: 'rgba(114, 9, 183, 0.08)',
    zIndex: 1,
  },
};

export default Hero;